import { c as _c } from "react/compiler-runtime";
import { Box, Heading, Spacer, Text, VStack } from '@chakra-ui/react';
import { SectionStepsList } from '@src/components/sco/Education/ContentTrackSectionDetail/SectionStepsList';
import { ContentTrackSection } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
type ContentTrackSectionDashboardProps = {
  contentTrackSection: ContentTrackSection;
};
export const ContentTrackSectionDashboard = props => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["20px", "20px", "20px", "20px", "40px"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.contentTrackSection.parentContentTrack.title) {
    t1 = <Text color="primary" textStyle="badgeSm">{props.contentTrackSection.parentContentTrack.title}</Text>;
    $[1] = props.contentTrackSection.parentContentTrack.title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["2xl", "5xl"];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.contentTrackSection.title) {
    t3 = <Heading size={t2}>{props.contentTrackSection.title}</Heading>;
    $[4] = props.contentTrackSection.title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <VStack align="flex-start">{t1}{t3}</VStack>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Spacer height={6} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== props.contentTrackSection) {
    t6 = <SectionStepsList cascade={true} contentTrackSection={props.contentTrackSection} contentTrackSteps={props.contentTrackSection.steps} />;
    $[10] = props.contentTrackSection;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <Box margin="0 auto" maxWidth="container.md" p={t0}>{t4}{t5}{t6}</Box>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
ContentTrackSectionDashboard.fragments = {
  ContentTrackSection: () => gql`
    fragment _ on ContentTrackSection {
      id
      title
      ${SectionStepsList.fragments.ContentTrackSection()}
    }
  `
};